import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownWideShort,
  faArrowUpWideShort,
  faWindowMinimize,
  faFont,
  faRulerVertical,
  faWeightScale,
  faPersonDress,
  faPerson,
  faSuitcase,
} from "@fortawesome/free-solid-svg-icons";
import { FC } from "react";
import styled from "styled-components";
import colors from "../../styles/colors";

interface ActiveProps {
    isActive?: boolean;
}

const Container = styled.div`
    justify-content: space-around;
    gap: 6px;
    flex-wrap: wrap;
`;

const Separator = styled.span`
    display: inline-block;
    color: rgba(255, 255, 255, 0.2);
    font-size: 20px;
    transform: rotate(90deg);
    margin: 0 2px;
`;

const IconButton = styled.button<ActiveProps>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 6px;
    border: 2px solid ${props => props.isActive ? colors.bgColorBordeaux : 'rgba(255,255,255,0.15)'};
    background-color: ${props => props.isActive ? colors.bgColorBordeaux : 'rgba(255,255,255,0.05)'};
    color: ${props => props.isActive ? 'gold' : 'rgba(255,255,255,0.6)'};
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    padding: 0;

    &:hover {
        border-color: ${colors.bgColorBordeaux};
        background-color: ${colors.bgColorBordeaux};
        color: white;
        transform: translateY(-1px);
        box-shadow: 0 3px 8px rgba(163, 27, 27, 0.4);
    }

    &:active {
        transform: translateY(0);
    }

    svg {
        width: 14px;
        height: 14px;
    }
`;

const OrderButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    border-radius: 6px;
    border: 2px solid rgba(255, 255, 255, 0.15);
    background-color: rgba(255, 255, 255, 0.05);
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    transition: all 0.15s ease-in-out;
    padding: 0;

    &:hover {
        border-color: gold;
        color: gold;
        transform: translateY(-1px);
        box-shadow: 0 3px 8px rgba(255, 215, 0, 0.2);
    }

    &:active {
        transform: translateY(0);
    }

    svg {
        width: 15px;
        height: 15px;
    }
`;

const Group = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
`;

interface FilterListWrestlerProps {
    isOrderDesc: boolean;
    currentOrder: string;
    isOrderByName: boolean;
    isOrderByHeight: boolean;
    isOrderByWeight: boolean;
    isFilterMan: boolean;
    isFilterWomen: boolean;
    isFilterManager: boolean;
    onOrderChange: (
        orderBy: string,
        isOrderDesc?: boolean,
        isFilterMan?: boolean,
        isFilterWomen?: boolean,
        isFilterManager?: boolean
    ) => void;
}

const FilterListWrestler: FC<FilterListWrestlerProps> = (props) => {
    const {
        isOrderDesc,
        currentOrder,
        isOrderByName,
        isOrderByHeight,
        isOrderByWeight,
        isFilterMan,
        isFilterWomen,
        isFilterManager,
        onOrderChange,
    } = props;

    function changeOrder(): void {
        if (isOrderByName) onOrderChange('name', !isOrderDesc);
        else if (isOrderByHeight) onOrderChange('height', !isOrderDesc);
        else if (isOrderByWeight) onOrderChange('weight', !isOrderDesc);
    }

    return (
        <Container className="col-4 d-flex align-items-center">
            <Group>
                <OrderButton
                    onClick={changeOrder}
                    title={isOrderDesc ? 'Ordine decrescente' : 'Ordine crescente'}
                >
                    <FontAwesomeIcon icon={isOrderDesc ? faArrowDownWideShort : faArrowUpWideShort} />
                </OrderButton>

                <Separator>
                    <FontAwesomeIcon icon={faWindowMinimize} />
                </Separator>

                <IconButton
                    isActive={isOrderByName}
                    onClick={() => onOrderChange('name')}
                    title="Ordina per nome"
                >
                    <FontAwesomeIcon icon={faFont} />
                </IconButton>

                <IconButton
                    isActive={isOrderByHeight}
                    onClick={() => onOrderChange('height')}
                    title="Ordina per altezza"
                >
                    <FontAwesomeIcon icon={faRulerVertical} />
                </IconButton>

                <IconButton
                    isActive={isOrderByWeight}
                    onClick={() => onOrderChange('weight')}
                    title="Ordina per peso"
                >
                    <FontAwesomeIcon icon={faWeightScale} />
                </IconButton>
            </Group>

            <Group>
                <IconButton
                    isActive={isFilterWomen}
                    onClick={() => onOrderChange(currentOrder, isOrderDesc, isFilterMan, !isFilterWomen, isFilterManager)}
                    title="Filtra per donna"
                >
                    <FontAwesomeIcon icon={faPersonDress} />
                </IconButton>

                <IconButton
                    isActive={isFilterMan}
                    onClick={() => onOrderChange(currentOrder, isOrderDesc, !isFilterMan, isFilterWomen, isFilterManager)}
                    title="Filtra per uomo"
                >
                    <FontAwesomeIcon icon={faPerson} />
                </IconButton>

                <IconButton
                    isActive={isFilterManager}
                    onClick={() => onOrderChange(currentOrder, isOrderDesc, isFilterMan, isFilterWomen, !isFilterManager)}
                    title="Filtra per manager"
                >
                    <FontAwesomeIcon icon={faSuitcase} />
                </IconButton>
            </Group>
        </Container>
    );
};

export default FilterListWrestler;
